import React from 'react';
import projects from '../data/projects';
import './ProjectList.css';

// `detailed` shows the full description and build notes (Projects page);
// otherwise just the tagline (home page teaser).
const ProjectList = ({ detailed = false }) => (
  <ul className={`project-list${detailed ? ' project-list-detailed' : ''}`}>
    {projects.map((project) => (
      <li key={project.id} className="project-row">
        <div className="project-heading">
          <h3>
            <a href={project.url} target="_blank" rel="noopener noreferrer">
              {project.name}
            </a>
          </h3>
          <span className="project-status">{project.status}</span>
        </div>
        <div className="project-body">
          <p className="project-tagline">{project.tagline}</p>
          {detailed && <p className="project-description">{project.description}</p>}
          {detailed && <p className="project-built">{project.built}</p>}
        </div>
        <a
          className="project-link"
          href={project.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${project.name} at ${project.urlLabel}`}
        >
          {project.urlLabel}
        </a>
      </li>
    ))}
  </ul>
);

export default ProjectList;
